import React, {useEffect, useState} from "react";
import { elastic as Menu } from "react-burger-menu";
import "./SideBar.css"
import {useDispatchNav, useNav, useUser} from "../../hooks";
import SimpleLineIcon from "react-simple-line-icons";
import {useHistory} from "react-router-dom";
import {useMall} from "../../hooks/useMall";
import {permission_api} from "../../Pages/PackMan/PackManService";

const SideBar =  props => {

    //Hooks

    const nav = useNav();
    const setNav = useDispatchNav();
    const history = useHistory()
     // const mall = useMall();
    const user = useUser();


    // states
    const [mallName,setMallName]= useState("");
    const [perm,set_perm]= useState([]);



    //Func

    const handleOnClose = ()=> setNav(false);

    const goTo = (page) =>  {
        setNav(false);
        history.push(`/${page}`);
    }

    const goToRoot = (page) =>  {
        setNav(false);
        history.push(`/${page}`);
    }

    const handleProfileName = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}

        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.first_name){
                return userObj.first_name+" "+userObj.last_name;
            }else {
                return "بدون نام";
            }
        }else {
            return "بدون نام";
        }
    }

    const handleProfilePhone = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}
        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.phone){return userObj.phone;}
        }else {
            return "بدون شماره";
        }
    }

    const logout = () =>{
        localStorage.removeItem('mallId');
        localStorage.removeItem('merchants');
        localStorage.removeItem('mallLogo');
        localStorage.removeItem('mallName');
        localStorage.removeItem('mall');
        localStorage.removeItem('user');
        localStorage.removeItem('cats');
        localStorage.removeItem('wait');
        localStorage.removeItem('token');
        localStorage.removeItem('allowNotif');
        localStorage.removeItem('merchantId');
        history.go('/home');
    }

    const dial = () =>{
        document.location.href="tel:0214452";
    }

    useEffect(()=>{
       let mallN =  localStorage.getItem('mallName');
       if(mallN){setMallName(mallN)}
    },)



    useEffect(()=>{
        console.log("nav : ",nav)
        if(nav){
            getPermission()
        }
    },[nav])

    const getPermission = async ()=>{
        try{
            const res = await permission_api()
            set_perm(res.data)
            console.log("res : ",res)
        }catch (e) {
            console.log(e)
        }
    }

    const hasPermission = (ids)=>{
        let filtered  = perm.map(p=>p.id)
        return ids.some(r=> filtered.indexOf(r) >= 0)
    }





    return (
        <Menu right  onClose={ handleOnClose } isOpen={ nav }    customBurgerIcon={ false }>
            <div className="side-profile-sec">
                <div className="side-profile-card">
                    <div className="side-profile-info">
                        <span className="profile-name">{handleProfileName()}</span>
                        <div className="wallet">
                            <span>{handleProfilePhone()}</span>
                        </div>
                    </div>
                    <div className="side-profile-img">
                        <img src="/other/profile-default-icon.png" alt=""/>
                    </div>
                </div>
                {/*<div className="wallet-inc">*/}
                {/*    <div className="wallet-inc-btn">*/}
                {/*        <span>افزایش موجودی</span>*/}
                {/*        <i className="fa fa-plus-square-o"></i>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="choose-mall">
                    {/*<SimpleLineIcon name="arrow-left"/>*/}
                    {/*<div className="choose-mall-info">*/}
                    {/*    <span className="choose-mall-info-label">انتخاب مرکز خرید</span>*/}
                    {/*    <span className="choose-mall-info-mallName">{mallName}</span>*/}
                    {/*</div>*/}
                </div>


                <div className="side-menu-list">
                    {/*<div className="side-menu-items">*/}
                    {/*    <span>تنظیمات</span>*/}
                    {/*    <SimpleLineIcon name="equalizer"/>*/}
                    {/*</div>*/}

                    <div className="side-menu-items" onClick={()=>{goToRoot('merchants')}}>
                        <span>مرچنت ها</span>
                        <SimpleLineIcon name="grid"/>
                    </div>


                    {hasPermission([11])?
                    <div className="side-menu-items" onClick={()=>{goToRoot('pack-man')}}>
                        <span>جمع آوری</span>
                        <SimpleLineIcon name="calendar"/>
                    </div>:null}




                    {/*<div className="side-menu-items">*/}
                    {/*    <span>درباره دیجیمال</span>*/}
                    {/*    <SimpleLineIcon name="energy"/>*/}
                    {/*</div>*/}

                    {hasPermission([9])?
                    <div className="side-menu-items" onClick={()=>{goToRoot('send-management')}}>
                        <span>مدیریت ارسال</span>
                        <SimpleLineIcon name="share"/>
                    </div>:null}


                    {hasPermission([12])?
                    <div className="side-menu-items"onClick={()=>{goToRoot('creditor')}}>
                        <span> بستانکارها</span>
                        <SimpleLineIcon name="user"/>
                    </div>:null}

                    {hasPermission([12])?
                    <div className="side-menu-items"onClick={()=>{goToRoot('peyk')}}>
                        <span>پیک</span>
                        <SimpleLineIcon name="user"/>
                    </div>:null}

                    {/*<div className="side-menu-items"onClick={()=>{goToRoot('geofence')}}>*/}
                    {/*    <span>محدوده ارسال</span>*/}
                    {/*    <SimpleLineIcon name="user"/>*/}
                    {/*</div>*/}

                    {/*<div className="side-menu-items"onClick={()=>{goToRoot('add-merchant')}}>*/}
                    {/*    <span>اضافه کردن مرچنت</span>*/}
                    {/*    <SimpleLineIcon name="user"/>*/}
                    {/*</div>*/}

                    {/*<div className="side-menu-items">*/}
                    {/*    <span>صندوق مجازی</span>*/}
                    {/*    <SimpleLineIcon name="handbag"/>*/}
                    {/*</div>*/}
                    <div className="side-menu-items" onClick={()=>{logout()}}>
                        <span>خروج از حساب کاربری</span>
                        <SimpleLineIcon name="logout"/>
                    </div>

                </div>

            </div>




            {/*<a className="menu-item" href="/">*/}
            {/*    Home*/}
            {/*</a>*/}

            {/*<a className="menu-item" href="/burgers">*/}
            {/*    Burgers*/}
            {/*</a>*/}

            {/*<a className="menu-item" href="/pizzas">*/}
            {/*    Pizzas*/}
            {/*</a>*/}

            {/*<a className="menu-item" href="/desserts">*/}
            {/*    Desserts*/}
            {/*</a>*/}
        </Menu>
    );
};

export {SideBar};
